module.exports = __webpack_public_path__ + "static/media/snowtrace-logo.7d2f728e.svg";